<!-- eslint-disable better-tailwindcss/no-unknown-classes -->
<script>
	import { fly } from 'svelte/transition';
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		loading = null,
		value = $bindable(),
		element = $bindable(),
		class: className = '',
		required = false,
		disabled = false,
		error = null,
		label = null,
		onchange = null,
		...props
	} = $props();
</script>

<InputWrapper {label} {error} class={className}>
	<div class="relative">
		{#if loading}
			<div
				transition:fly|local
				class="absolute right-0 grid h-full place-items-center"
			>
				<!-- eslint-disable better-tailwindcss/no-unknown-classes -->
				<svg
					class="m-2 w-6 stroke-indow-grey"
					stroke="#000"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
					><g class="spinner"
						><circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3" /></g
					></svg
				>
				<!-- eslint-enable better-tailwindcss/no-unknown-classes -->
			</div>
		{:else}
			<div
				transition:fly|local
				class="absolute right-0 bottom-0 m-0 grid h-full place-items-center p-0"
			>
				<svg
					class="m-2 w-6 fill-indow-grey"
					viewBox="0 0 20 20"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
						clip-rule="evenodd"
					/>
				</svg>
			</div>
		{/if}
		<input
			bind:value
			bind:this={element}
			type="search"
			class={[
				'w-full content-center rounded-md border-indow-grey-light',
				{ 'cursor-not-allowed bg-indow-grey-light': disabled },
				{ 'border-indow-red': error },
			]}
			aria-invalid={error ? true : undefined}
			{name}
			{required}
			{disabled}
			{onchange}
			{...props}
		/>
	</div>
</InputWrapper>

<style>
	/* clears the ‘X’ from Internet Explorer */
	input[type='search']::-ms-clear {
		display: none;
		width: 0;
		height: 0;
	}
	input[type='search']::-ms-reveal {
		display: none;
		width: 0;
		height: 0;
	}
	/* clears the ‘X’ from Chrome */
	input[type='search']::-webkit-search-decoration,
	input[type='search']::-webkit-search-cancel-button,
	input[type='search']::-webkit-search-results-button,
	input[type='search']::-webkit-search-results-decoration {
		display: none;
	}

	.spinner {
		transform-origin: center;
		animation: spinner_rotate 2s linear infinite;
	}

	.spinner circle {
		stroke-linecap: round;
		animation: spinner 1.5s ease-in-out infinite;
	}

	@keyframes spinner_rotate {
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes spinner {
		0% {
			stroke-dasharray: 0 150;
			stroke-dashoffset: 0;
		}
		47.5% {
			stroke-dasharray: 42 150;
			stroke-dashoffset: -16;
		}
		95%,
		100% {
			stroke-dasharray: 42 150;
			stroke-dashoffset: -59;
		}
	}
</style>
